import React from 'react';
import { TextField, Box } from '@mui/material';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const SearchBar: React.FC<Props> = ({ value, onChange }) => (
  <Box my={1}>
    <TextField
      fullWidth
      variant="outlined"
      placeholder="Search for products..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        sx: {
          height: 39,
          padding: '0 10px',
          backgroundColor: '#f1f1f1',
          borderRadius: '12px',
          fontSize: 14,
          '& fieldset': {
            borderColor: '#ddd',
          },
        },
      }}
    />
  </Box>
);

export default SearchBar;


